/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import {
    BaseControl,
    Flex,
    FlexItem,
    FlexBlock,
    Button,
    ColorIndicator,
    ColorPicker,
    Dashicon
} from '@wordpress/components';
import { useState } from '@wordpress/element';
import './style.scss';

/**
 * Color Control
 */

const colors = [
    { name: 'Black', color: '#000000' },
    { name: 'White', color: '#ffffff' },
    { name: 'Grey', color: '#757575' },
    { name: 'Red', color: '#e53935' },
    { name: 'Pink', color: '#d81b60' },
    { name: 'Purple', color: '#8e24aa' },
    { name: 'Deep Purple', color: '#5e35b1' },
    { name: 'Indigo', color: '#3949ab' },
    { name: 'Blue', color: '#1e88e5' },
    { name: 'Light Blue', color: '#039be5' },
    { name: 'Cyan', color: '#00acc1' },
    { name: 'Teal', color: '#00897b' },
    { name: 'Green', color: '#43a047' },
    { name: 'Light Green', color: '#7cb342' },
    { name: 'Lime', color: '#c0ca33' },
    { name: 'Yellow', color: '#fdd835' },
    { name: 'Amber', color: '#ffb300' },
    { name: 'Orange', color: '#fb8c00' },
    { name: 'Deep Orange', color: '#f4511e' },
    { name: 'Brown', color: '#6d4c41' },
    { name: 'Blue Grey', color: '#546e7a' },
    { name: 'Bistre', color: '#3b2d1b' },
    { name: 'Magenta', color: '#e91e63' },
    { name: 'Lavender', color: '#b39ddb' },

];


const ColorControl = ({ label, color, onChange, colorName }) => {
    const [showColorPanel, setShowColorPanel] = useState(false);

    const closePopup = () => setShowColorPanel(false);
    return (
        <div className="gutnm-color-control-wrapper">
            <Flex justify={{ justifyContent: 'flex-end' }} gap={0}>
                <FlexBlock>
                    <BaseControl
                        id="color-control"
                        label={label ? label : __('Color', 'gutenium')}
                    />
                </FlexBlock>
                <FlexItem>
                    <Button
                        className="gutnm-color-control"
                        onClick={() => setShowColorPanel(true)}
                    >
                        <ColorIndicator colorValue={color} />
                    </Button>
                </FlexItem>
                {color && (
                    <FlexItem>
                        <Button
                            className="reset-icon"
                            onClick={() => onChange({ [colorName]: '' })}
                        >
                            <Dashicon icon="image-rotate" />
                        </Button>
                    </FlexItem>
                )}
                {showColorPanel && (
                    <div className="gutnm-custom-popup-overlay" onClick={closePopup}>
                        <div
                            className="gutnm-custom-color-popup-content"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <BaseControl>
                                <ColorPicker
                                    color={color}
                                    disableAlpha={false}
                                    onChangeComplete={(value) => {
                                        onChange({ [colorName]: value.hex });
                                    }}
                                />
                                <div className="bwd-color-control-popover">
                                    <Flex gap="8px" wrap>
                                        {colors.map(({ name, color }) => (
                                            <Button
                                                key={color}
                                                className="color-swatch-button"
                                                style={{ padding: 0 }}
                                                onClick={() => {
                                                    onChange({ [colorName]: color });
                                                    setShowColorPanel(false);
                                                }}
                                                label={name}
                                            >
                                                <ColorIndicator colorValue={color} />
                                            </Button>
                                        ))}
                                    </Flex>
                                </div>
                            </BaseControl>
                        </div>
                    </div>
                )}
            </Flex>
        </div>
    );
};


export default ColorControl;